var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset53(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 309.04 60.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5b3d3a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "disgusted"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,10.36A8.1,8.1,0,0,1,2.86,6.59,15.54,15.54,0,0,1,7,4.43a35.41,35.41,0,0,1,8.85-1.7A86,86,0,0,1,33.5,3.5,154.55,154.55,0,0,1,50.73,7C56.39,8.48,62,10.28,67.47,12.29s11,4,16.47,6.37A63.43,63.43,0,0,1,99.38,28a54.52,54.52,0,0,1,12.35,14C115,47.4,117,53.92,116.26,60.09l-1.37.3a50.31,50.31,0,0,0-10.83-12.08,111.33,111.33,0,0,0-12.88-8.94c-4.52-2.75-9.1-5.54-13.7-8.53a143.71,143.71,0,0,0-14.4-8.31c-5-2.47-10.06-4.73-15.23-6.77a152.83,152.83,0,0,0-15.76-5.45A86,86,0,0,0,15.85,7.09a32.59,32.59,0,0,0-8.09.19c-2.58.43-5.2,1.39-6.47,3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307.73,9.27C306.56,7,304,5.91,301.45,5.36a32.56,32.56,0,0,0-8-.55,86.69,86.69,0,0,0-16.32,2.48A151.49,151.49,0,0,0,261.16,12q-7.86,2.7-15.46,6.06a116,116,0,0,0-14.49,7.74c-4.63,2.85-9.17,5.59-13.77,8.24a158.5,158.5,0,0,0-13.31,8.64,80,80,0,0,0-6.24,5,50.69,50.69,0,0,0-5.81,6l-1.34-.43a20.26,20.26,0,0,1,.45-4.65,27.36,27.36,0,0,1,1.31-4.51,40.81,40.81,0,0,1,4.34-8.28,60.37,60.37,0,0,1,12.6-13.39,62.3,62.3,0,0,1,15.6-9c5.53-2.25,11.18-4,16.74-5.84s11.2-3.3,16.9-4.55A157.31,157.31,0,0,1,276,.44a86.37,86.37,0,0,1,17.61,0,35.45,35.45,0,0,1,8.74,2.09,15.49,15.49,0,0,1,4,2.33A8.09,8.09,0,0,1,309,8.77Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset53);
export default __webpack_public_path__ + "static/media/Asset 53.773eb274.svg";
export { ForwardRef as ReactComponent };